// extracted by mini-css-extract-plugin
export default {"switcher":"Switcher_switcher__AWKCu","option":"Switcher_option__whgiz","chosen":"Switcher_chosen__SgrxB","subtitle":"Switcher_subtitle__kJec3"};